import React from 'react';
import { Card } from './Card';
import { TrafficIcon } from '../icons/TrafficIcon';
import { AttentionIcon } from '../icons/AttentionIcon';
import { Diff } from '../Diff';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { ComparePreset } from '../../model/datePicker/types';
import { Information } from '../Information';
import { t } from '../../i18n';

const OffPeakTimeCard = ({ hour, total, previousTotal, comparePreset }: Props) => {
  return (
    <Card className="card-border-shadow-info">
      <div className="card-body">
        <div className="d-flex align-items-center">
          <Information id="offPeakTime" content={<span>{t('cards.offPeakTime')}</span>} />
          <Information id="offPeakTime" showMore={true} className="ms-2" />
        </div>
        <small className="d-flex align-items-center">
          <Diff value={getDiff(total, previousTotal)} />
          <div className="text-muted ms-2">{getComparePresetLabel(comparePreset)} ({previousTotal})</div>
        </small>
        <div className="row justify-content-center mt-4">
          <div className="col-6">
            <div className="d-flex flex-column align-items-center">
              <AttentionIcon />
              <h4 className="mb-0 mt-2">{hour}</h4>
              <div className="d-flex align-items-center">
                <Information id="peakHour" content={<small className="text-muted me-2">{t('cards.offPeakHour')}</small>} />
                <Information id="peakHour" showMore={true} />
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex flex-column align-items-center">
              <TrafficIcon />
              <h4 className="mb-0 mt-2">{total}</h4>
              <div className="d-flex align-items-center">
                <Information id="totalPeople" content={<small className="text-muted me-2">{t('cards.totalPeople')}</small>} />
                <Information id="totalPeople" showMore={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  hour: string,
  total: number,
  previousTotal: number,
  comparePreset?: ComparePreset
}

export { OffPeakTimeCard };